export default __webpack_public_path__ + "static/media/D66E0D47-7CA0-46D9-8CC9-B83308EF7464_1_105_c.8d434b25.jpeg";